import { getDesiredAssignmentsSchema } from '../../intune-utlity';
import { getConfigurationPolicySettingsForEdgeSchema } from '../helper';
import { DeviceConfigurationWindowsEdgeBlockPasswordSavingSchema } from './model';

export const updateSchema = (formValue: any, schema: DeviceConfigurationWindowsEdgeBlockPasswordSavingSchema): any => {
    // update your schema here
    schema.contains.properties.description.const = formValue.policy.description;

    schema.contains.properties.assignments = getDesiredAssignmentsSchema(formValue);

    schema.contains.properties.settings = getConfigurationPolicySettingsForEdgeSchema(formValue.settings);
    return schema;
};
